import { render, staticRenderFns } from "./automatic.vue?vue&type=template&id=4c19bb4e&"
import script from "./automatic.vue?vue&type=script&lang=js&"
export * from "./automatic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports